import { ActionTypes } from 'redux/utils/Delete'

export default ActionTypes('INCIDENT_REPORT')